import ImageTool from "@editorjs/image";

class ExtendedImageTool extends ImageTool {
  static get isReadOnlySupported() {
    return true;
  }

  static get merge() {
    return true; // Разрешает объединение кастомных полей
  }

  constructor({ data, config, api, readOnly, block }) {
    // Вызываем super() ПЕРВЫМ делом
    super({ data, config, api, readOnly, block });

    // Теперь можно работать с this
    this._link = data?.link;
    this.imageContainer = null;
    this.observer = null;
  }

  renderSettings() {
    const settings = super.renderSettings();

    settings.push({
      name: "addLink",
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-link"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>',
      title: "Добавить ссылку",
      toggle: true,
      isActive: () => !!this.data.link,
      onActivate: () => this.addLink(),
    });

    return settings;
  }

  addLink() {
    if (this.readOnly) return;

    const currentLink = this.data.link || "";

    const modal = document.createElement("div");
    modal.className = "image-link-modal";

    const modalContent = document.createElement("div");
    modalContent.className = "image-link-modal-content";

    const input = document.createElement("input");
    input.type = "text";
    input.className = "image-link-modal-input";
    input.placeholder = "Введите URL ссылки";
    input.value = currentLink;

    const buttons = document.createElement("div");
    buttons.className = "image-link-modal-buttons";

    const cancelBtn = document.createElement("button");
    cancelBtn.className = "image-link-modal-button image-link-modal-cancel";
    cancelBtn.textContent = "Отмена";

    const saveBtn = document.createElement("button");
    saveBtn.className = "image-link-modal-button image-link-modal-save";
    saveBtn.textContent = "Добавить";

    buttons.appendChild(cancelBtn);
    buttons.appendChild(saveBtn);

    modalContent.appendChild(input);
    modalContent.appendChild(buttons);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);

    const closeModal = () => {
      document.body.removeChild(modal);
    };

    cancelBtn.addEventListener("click", closeModal);

    saveBtn.addEventListener("click", () => {
      const newLink = input.value.trim() || undefined;
      this.data.link = newLink;
      this._link = newLink; // Обновляем сохранённую ссылку
      this.applyLinkWrapper();
      this.save();
      this.block.dispatchChange();
      closeModal();
    });
    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        closeModal();
      }
    });

    input.focus();
  }

  render() {
    const container = super.render();
    this.imageContainer = container.querySelector(".image-tool__image");
    this.applyLinkWrapper();
    return container;
  }

  applyLinkWrapper() {
    try {
      if (!this.imageContainer) return;

      const img = this.imageContainer.querySelector(".image-tool__image-picture");
      if (!img) return;

      // Удаляем старую обёртку
      const existingLink = img.closest('a[target="_blank"]');
      if (existingLink) {
        existingLink.replaceWith(...existingLink.childNodes);
      }

      // Используем сохранённый this._link
      if (this._link) {
        const link = document.createElement("a");
        link.href = this._link;
        link.target = "_self";
        link.rel = "noopener noreferrer";

        img.parentNode.insertBefore(link, img);
        link.appendChild(img);
      }
    } catch (error) {
      console.error("Error applying link wrapper:", error);
    }
  }

  updateLinkElement() {
    if (!this.imageContainer) return;

    const existingLink = this.imageContainer.parentElement.closest('a[target="_self"]');
    if (existingLink) {
      const parent = existingLink.parentNode;
      parent.insertBefore(this.imageContainer, existingLink);
      existingLink.remove();
    }

    if (this._link) {
      // Используем this._link вместо this.data.link
      const link = document.createElement("a");
      link.href = this._link;
      link.target = "_self";
      link.rel = "noopener noreferrer";

      const parent = this.imageContainer.parentNode;
      parent.insertBefore(link, this.imageContainer);
      link.appendChild(this.imageContainer);
    }
  }

  save() {
    const savedData = super.save();
    if (this._link) {
      savedData.link = this._link; // Сохраняем link в выходных данных
    }
    return savedData;
  }
  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    // Удаляем другие созданные ресурсы, если они есть
    this.imageContainer = null;
  }

  static get sanitize() {
    return {
      ...super.sanitize,
      link: {
        href: true,
        target: true,
        rel: true,
      },
    };
  }

  static get merge() {
    return true;
  }
}

export default ExtendedImageTool;
